export default __webpack_public_path__ + "static/media/convictional.2b5e48fd.png";